import React, { useEffect, useState } from 'react';
import { Select, Spin } from 'antd';
import debounce from "lodash/debounce"; 

const { Option } = Select;

const Dropdown = ({
  mode,
  isFAQ,
  subService,
  options,
  city,
  defaultValue,
  data,
  isBusiness,
  disabled,
  placeholder,
  onChange,
  className,
  loadMoreData, // Function to load more data
  isService,
  price,
  loader,
  isUser,
  fetchData,
  onDropDownClose = null
}) => {
  const [value, setValue] = useState(defaultValue);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState(data || []);
  const [isInitialSearch, setIsInitialSearch] = useState("");
  const [itemPerPage, setItemPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    setItems(data || []);
  }, [data]);

  const handleChange = (selectedValue) => {
    setValue(selectedValue);
    onChange(selectedValue);
  };

  const handlePopupScroll = async (event) => {
    const { target } = event;
    const tolerance = 1;

    const scrolledPosition = target.scrollTop + target.offsetHeight;
    const totalHeight = target.scrollHeight;

    if (Math.abs(scrolledPosition - totalHeight) <= tolerance && !loading) {
      setLoading(true);
      const newPage = currentPage + 1;
      await loadMore(newPage, itemPerPage, searchText);
      setCurrentPage(newPage);
      setLoading(false);
    }
  };

  const loadMore = async (page, itemPerPage, searchText) => {
    const moreData = await loadMoreData(page, itemPerPage, searchText);
  };

  const filterOption = (input, option) => {
    const children = option.children;
    if (typeof children === 'string') {
      return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
    return false;
  };

  const handleSearch = debounce(async (value) => {
    if (isUser && value) {
      await fetchData(1, value);
    }

    if(isBusiness && value) {
      if(isInitialSearch){
        setCurrentPage(1);
        setIsInitialSearch(false);
      }
      setItemPerPage(50);
      setSearchText(value);
      const payload = {
        pageNumber: currentPage,
        itemPerPage: 50,
        text: value
      };
      await fetchData(payload);
    }
  }, 300);

  const handleDropdownChange = (open) => {
    if(!open) {
      setSearchText("");
      if(onDropDownClose) {
        onDropDownClose();
      }
    }
  };

  useEffect(() => {
    if(searchText) {
      setCurrentPage(1);
    }
  }, [searchText])

  return (
    <Select
      placeholder={placeholder}
      disabled={disabled}
      showSearch
      onSearch={(isUser || isBusiness) ? handleSearch : undefined}
      filterOption={filterOption}
      onPopupScroll={handlePopupScroll}
      className={
        className
          ? className
          : '!h-5.4 flex justify-start items-center rounded-xl border-grey hover:border-primaryPurple !focus:border-primaryPurple lg:w-31 xl:w-40'
      }
      style={{ backgroundColor: '#F7F6F8' }}
      mode={mode === 'multiple' ? 'multiple' : ''}
      value={value}
      onChange={handleChange}
      notFoundContent={
        loader ? (
          <Spin size="small" />
        ) : items.length === 0 ? (
          'Data not found'
        ) : null
      }
      onDropdownVisibleChange={handleDropdownChange}
    >
      {items?.map((category, i) => (
        <Option
          key={i}
          title={category?.name}
          value={
            city
              ? category?.name
              : subService
              ? `${category?.serviceName} -  Price: $${category?.servicePrice} -  Discount: ${category?.discount}%`
              : isFAQ
              ? category
              : isBusiness
              ? category?._id
              : isService
              ? category?._id
              : price
              ? category.id
              : category.abbreviation || category._id
          }
        >
          {isBusiness
            ? category?.businessName
            : isUser
            ? `${category?.firstName} ${category?.lastName} (${category?.email})`
            : price
            ? `$${category?.price} ${
                category?.description ? `--- (${category?.description})` : ''
              }`
            : category?.name ?? category?.serviceName}
        </Option>
      ))}
    </Select>
  );
};

export default Dropdown;